import { Injectable } from '@angular/core';

import {bombasRoute, bombasAuditoriaRoute} from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import {editRoute, newRoute, detailRoute, configuracaoRoute} from "../../../shared/services/data.service";
import { abastecimentosRoute } from "../../shared/data.service";

@Injectable()
export class BombaNavigationService {
    configuracaoRoute: string = configuracaoRoute;

    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        let router: string = abastecimentosRoute + '/' + configuracaoRoute + '/' + bombasRoute;
        this._authService.navigateTo(router);
    }

    goToNew() {
        let router: string = abastecimentosRoute + '/' + configuracaoRoute + '/' + bombasRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        let router: string = abastecimentosRoute + '/' + configuracaoRoute + '/' + bombasRoute + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }

    goToDetail(objectId: number) {
        let router: string = abastecimentosRoute + '/' + bombasRoute + '/' + detailRoute;
        this._authService.navigateTo(router, objectId);
    }

    //auditoria
    goToAuditoriaList() {
        let router: string = abastecimentosRoute + '/' +  bombasAuditoriaRoute;
        this._authService.navigateTo(router);
    }

    goToAuditoriaDetail(bombaId: number) {
        let router: string = abastecimentosRoute + '/' + bombasAuditoriaRoute + '/' + detailRoute;
        this._authService.navigateTo(router, bombaId);
    }

    goToAuditar(bombaId: number) {
        let router: string = abastecimentosRoute + '/' + bombasAuditoriaRoute + '/auditar';
        this._authService.navigateTo(router, bombaId);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/shared/bomba-navigation.service.ts
 **/